import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import moment from "jalali-moment";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";

import utils from "../../components/toastify/toastify";
import DatePicker from "react-modern-calendar-datepicker";

const AddPaymentToUser = (props) => {
  const [
    get_user_details_error,
    get_user_details_loading,
    get_user_details_data,
    get_user_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_user_details",
    body: {
      user_id: props.match.params.id,
    },
  });

  const [
    get_products_error,
    get_products_loading,
    get_products_data,
    get_products_function,
  ] = useRequest({
    method: "get",
    url: "/get_products",
  });

  let [options, set_options] = useState();

  useEffect(() => {
    if (get_user_details_data) {
      // console.log(get_user_details_data.data.user_data.products);
      set_options(
        get_user_details_data.data.user_products_data
          ? get_user_details_data.data.user_products_data
          : []
      );
    }
  }, [get_user_details_data]);

  const [selectedDay, setSelectedDay] = useState(null);

  const [final_products, set_final_products] = useState([
    // {
    //   product_id: null,
    //   payment: true,
    //   support_all_payment: true,
    //   term_ids: [
    //     {
    //       term_id: null,
    //       payment: null,
    //       support_payment: null,
    //     },
    //   ],
    // },
  ]);

  const [price, set_price] = useState(null);
  const [more_information, set_more_information] = useState(null);
  const [_tracking_code, set__tracking_code] = useState(null);
  const [confirmation_photo, set_confirmation_photo] = useState(null);
  const [fish_img, set_fish_img] = useState(null);

  useEffect(() => {
    // const defaultValue = {
    //   year: Number(moment(Date.now()).locale("fa").format("YYYY")),
    //   month: Number(moment(Date.now()).locale("fa").format("M")),
    //   day: Number(moment(Date.now()).locale("fa").format("D")),
    // };
    // setSelectedDay(defaultValue);
    // set_final_product((i) => ({
    //   ...i,
    //   creation_date: moment(
    //     String(
    //       `${defaultValue.year}/${
    //         String(defaultValue.month).length === 1
    //           ? "0" + defaultValue.month
    //           : defaultValue.month
    //       }/${
    //         String(defaultValue.day).length === 1
    //           ? "0" + defaultValue.day
    //           : defaultValue.day
    //       }`
    //     ),
    //     "jYYYY/jMM/jDD HH:mm"
    //   ).toISOString(),
    // }));
  }, []);

  const sendData = () => {
    var formData = new FormData();

    var $white = "#fff";
    $.blockUI({
      message:
        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

      // timeout: 2000, //unblock after 2 seconds
      overlayCSS: {
        backgroundColor: $white,
        opacity: 0.8,
        cursor: "wait",
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
      },
    });
    formData.append("products", JSON.stringify(final_products));
    formData.append("manual", true);
    formData.append("fish_img", fish_img);
    formData.append("confirmation_photo", confirmation_photo);
    formData.append("more_information", more_information);
    formData.append("_tracking_code", _tracking_code);
    formData.append("price", price);
    formData.append("user_id", props.match.params.id);

    storage.load("token").then((res) => {
      if (!res) return Promise.reject();
      Axios.post("/add_payment_to_user", formData, {
        headers: {
          "x-auth": res,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          history.push("/dashboard/userDetails/" + props.match.params.id);
          $.unblockUI();
        })
        .catch((err) => {
          utils.showAlert("خطایی به وجود آمده است", "error");
          $.unblockUI();
        });
    });
  };

  console.log(final_products);

  //   {
  //     term_id: null,
  //     payment: null,
  //     support_payment: null,
  //   },
  // const [product_data, set_product_Data] = useState(null);

  // useEffect(() => {
  //   if (final_product.product_id) {
  //     set_product_Data(options.find((i) => i._id === final_product.product_id));
  //   } else {
  //     set_product_Data(null);
  //   }
  // }, [final_product]);

  let history = useHistory();

  //   const [creation_date, set_creation_date] = useState(null);

  const [
    add_product_user_error,
    add_product_user_loading,
    add_product_user_data,
    add_product_user_function,
  ] = useRequest({
    method: "post",
    isFunction: true,
    url: "/add_product_user",
    body: {
      user_id: props.match.params.id,
      // product: final_product,
    },
  });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن تراکنش جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن تراکنش جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                {/* <input
                                  type="text"
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                  class="form-control"
                                  placeholder="نام کاربری"
                                  value={user_name}
                                  onChange={(e) =>
                                    set_user_name(e.target.value)
                                  }
                                /> */}
                              </div>
                              {options
                                ? options.map(({ product_id }) => (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          margin: "10px",
                                          marginRight: "0px",
                                        }}
                                      >
                                        -{" "}
                                        <input
                                          style={{
                                            marginRight: "5px",
                                          }}
                                          checked={
                                            final_products.find(
                                              (i) =>
                                                String(i.product_id) ===
                                                String(product_id._id)
                                            )
                                              ? true
                                              : false
                                          }
                                          onChange={(e) =>
                                            set_final_products((i) =>
                                              e.target.checked
                                                ? product_id.type === "courses"
                                                  ? [
                                                      ...i.filter(
                                                        (i) =>
                                                          String(
                                                            i.product_id
                                                          ) !==
                                                          String(product_id._id)
                                                      ),
                                                      {
                                                        product_id:
                                                          product_id._id,
                                                        payment: true,
                                                        support_all_payment: true,
                                                        term_ids: [],
                                                      },
                                                    ]
                                                  : [
                                                      ...i.filter(
                                                        (i) =>
                                                          String(
                                                            i.product_id
                                                          ) !==
                                                          String(product_id._id)
                                                      ),
                                                      {
                                                        product_id:
                                                          product_id._id,
                                                      },
                                                    ]
                                                : [
                                                    ...i.filter(
                                                      (i) =>
                                                        String(i.product_id) !==
                                                        String(product_id._id)
                                                    ),
                                                  ]
                                            )
                                          }
                                          type="checkbox"
                                        />
                                        <span
                                          style={{
                                            marginRight: "5px",
                                          }}
                                        >
                                          {product_id.title}
                                        </span>
                                      </div>

                                      {product_id.type === "courses" &&
                                      final_products.find(
                                        (i) =>
                                          String(i.product_id) ===
                                          String(product_id._id)
                                      ) &&
                                      (product_id.files.length === 0 ||
                                        !product_id.files) ? (
                                        <>
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              marginBottom: "10px",
                                              marginRight: "20px",
                                            }}
                                          >
                                            <span
                                              style={{ marginLeft: "10px" }}
                                            >
                                              پرداخت کامل :{" "}
                                            </span>
                                            <input
                                              type="checkbox"
                                              checked={
                                                final_products.find(
                                                  (i) =>
                                                    String(i.product_id) ===
                                                    String(product_id._id)
                                                ).payment
                                              }
                                              onChange={(e) =>
                                                set_final_products((i) => [
                                                  ...i.map((i) =>
                                                    String(i.product_id) ===
                                                    String(product_id._id)
                                                      ? {
                                                          ...i,
                                                          payment:
                                                            e.target.checked,
                                                        }
                                                      : i
                                                  ),
                                                ])
                                              }
                                            />
                                          </div>
                                          {!final_products.find(
                                            (i) =>
                                              String(i.product_id) ===
                                              String(product_id._id)
                                          ).payment ? (
                                            <>
                                              {product_id.terms.map((i) => (
                                                <div
                                                  style={{
                                                    marginBottom: "5px",
                                                    marginRight: "25px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      checked={
                                                        final_products
                                                          .find(
                                                            (i) =>
                                                              String(
                                                                i.product_id
                                                              ) ===
                                                              String(
                                                                product_id._id
                                                              )
                                                          )
                                                          .term_ids.find(
                                                            (_i) =>
                                                              _i.term_id ===
                                                                i._id &&
                                                              _i.payment
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                      onChange={(e) => {
                                                        set_final_products(
                                                          (item) => [
                                                            ...item.map(
                                                              (my_item) =>
                                                                my_item.term_ids
                                                                  ? {
                                                                      ...my_item,
                                                                      term_ids:
                                                                        e.target
                                                                          .checked
                                                                          ? my_item.term_ids.find(
                                                                              (
                                                                                _i
                                                                              ) =>
                                                                                _i.term_id ===
                                                                                i._id
                                                                            )
                                                                            ? [
                                                                                {
                                                                                  term_id:
                                                                                    i._id,
                                                                                  payment: true,
                                                                                  support_payment:
                                                                                    my_item.term_ids.find(
                                                                                      (
                                                                                        _i
                                                                                      ) =>
                                                                                        _i.term_id ===
                                                                                        i._id
                                                                                    )
                                                                                      ? my_item.term_ids.find(
                                                                                          (
                                                                                            _i
                                                                                          ) =>
                                                                                            _i.term_id ===
                                                                                            i._id
                                                                                        )
                                                                                          .support_payment
                                                                                      : my_item.support_all_payment,
                                                                                },
                                                                                ...my_item.term_ids.filter(
                                                                                  (
                                                                                    _i
                                                                                  ) =>
                                                                                    _i.term_id !==
                                                                                    i._id
                                                                                ),
                                                                              ]
                                                                            : [
                                                                                ...my_item.term_ids,
                                                                                {
                                                                                  term_id:
                                                                                    i._id,
                                                                                  payment: true,
                                                                                  support_payment:
                                                                                    my_item.support_all_payment,
                                                                                },
                                                                              ]
                                                                          : my_item.term_ids.filter(
                                                                              (
                                                                                _i
                                                                              ) =>
                                                                                _i.term_id !==
                                                                                i._id
                                                                            ),
                                                                    }
                                                                  : my_item
                                                            ),
                                                          ]
                                                        );
                                                        // set_product_Data(
                                                        //   product_data
                                                        // );
                                                      }}
                                                    />
                                                    {i.title}
                                                  </div>
                                                </div>
                                              ))}
                                            </>
                                          ) : null}
                                          <div
                                            style={{
                                              marginTop: "10px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                marginLeft: "10px",
                                                marginRight: "20px",
                                              }}
                                            >
                                              پشتیبانی کامل :{" "}
                                            </span>
                                            <input
                                              type="checkbox"
                                              checked={
                                                final_products.find(
                                                  (i) =>
                                                    String(i.product_id) ===
                                                    String(product_id._id)
                                                ).support_all_payment
                                              }
                                              onChange={(e) =>
                                                set_final_products((i) => [
                                                  ...i.map((i) =>
                                                    String(i.product_id) ===
                                                    String(product_id._id)
                                                      ? {
                                                          ...i,
                                                          support_all_payment:
                                                            e.target.checked,
                                                        }
                                                      : i
                                                  ),
                                                ])
                                              }

                                              // checked={
                                              //   final_product.support_all_payment
                                              // }
                                              // onChange={(e) =>
                                              //   set_final_product((i) => ({
                                              //     ...i,
                                              //     support_all_payment:
                                              //       e.target.checked,
                                              //   }))
                                              // }
                                            />
                                          </div>
                                          {!final_products.find(
                                            (i) =>
                                              String(i.product_id) ===
                                              String(product_id._id)
                                          ).support_all_payment ? (
                                            <>
                                              {product_id.terms.map((i) => (
                                                <div
                                                  style={{
                                                    marginBottom: "5px",
                                                    marginRight: "25px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      checked={
                                                        final_products
                                                          .find(
                                                            (i) =>
                                                              String(
                                                                i.product_id
                                                              ) ===
                                                              String(
                                                                product_id._id
                                                              )
                                                          )
                                                          .term_ids.find(
                                                            (_i) =>
                                                              _i.term_id ===
                                                                i._id &&
                                                              _i.support_payment
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                      onChange={(e) => {
                                                        set_final_products(
                                                          (item) => [
                                                            ...item.map(
                                                              (my_item) =>
                                                                my_item.term_ids
                                                                  ? {
                                                                      ...my_item,
                                                                      term_ids:
                                                                        e.target
                                                                          .checked
                                                                          ? my_item.term_ids.find(
                                                                              (
                                                                                _i
                                                                              ) =>
                                                                                _i.term_id ===
                                                                                i._id
                                                                            )
                                                                            ? [
                                                                                {
                                                                                  term_id:
                                                                                    i._id,
                                                                                  payment:
                                                                                    my_item.term_ids.find(
                                                                                      (
                                                                                        _i
                                                                                      ) =>
                                                                                        _i.term_id ===
                                                                                        i._id
                                                                                    )
                                                                                      ? my_item.term_ids.find(
                                                                                          (
                                                                                            _i
                                                                                          ) =>
                                                                                            _i.term_id ===
                                                                                            i._id
                                                                                        )
                                                                                          .payment
                                                                                      : my_item.payment,
                                                                                  support_payment: true,
                                                                                },
                                                                                ...my_item.term_ids.filter(
                                                                                  (
                                                                                    _i
                                                                                  ) =>
                                                                                    _i.term_id !==
                                                                                    i._id
                                                                                ),
                                                                              ]
                                                                            : [
                                                                                ...my_item.term_ids,
                                                                                {
                                                                                  term_id:
                                                                                    i._id,
                                                                                  payment:
                                                                                    my_item.payment,
                                                                                  support_payment: true,
                                                                                },
                                                                              ]
                                                                          : my_item.term_ids.filter(
                                                                              (
                                                                                _i
                                                                              ) =>
                                                                                _i.term_id !==
                                                                                i._id
                                                                            ),
                                                                    }
                                                                  : my_item
                                                            ),
                                                          ]
                                                        );
                                                        // set_product_Data(
                                                        //   product_data
                                                        // );
                                                      }}

                                                      // checked={
                                                      //   final_product.term_ids.find(
                                                      //     (_i) =>
                                                      //       _i.term_id === i._id &&
                                                      //       _i.support_payment
                                                      //   )
                                                      //     ? true
                                                      //     : false
                                                      // }

                                                      // onChange={(e) => {
                                                      //   set_final_product(
                                                      //     (item) => ({
                                                      //       ...item,
                                                      //       term_ids: e.target
                                                      //         .checked
                                                      //         ? item.term_ids.find(
                                                      //             (_i) =>
                                                      //               _i.term_id ===
                                                      //               i._id
                                                      //           )
                                                      //           ? [
                                                      //               {
                                                      //                 term_id:
                                                      //                   i._id,
                                                      //                 payment:
                                                      //                   item.term_ids.find(
                                                      //                     (_i) =>
                                                      //                       _i.term_id ===
                                                      //                       i._id
                                                      //                   )
                                                      //                     ? item.term_ids.find(
                                                      //                         (
                                                      //                           _i
                                                      //                         ) =>
                                                      //                           _i.term_id ===
                                                      //                           i._id
                                                      //                       )
                                                      //                         .payment
                                                      //                     : final_product.payment,
                                                      //                 support_payment: true,
                                                      //               },
                                                      //               ...item.term_ids.filter(
                                                      //                 (_i) =>
                                                      //                   _i.term_id !==
                                                      //                   i._id
                                                      //               ),
                                                      //             ]
                                                      //           : [
                                                      //               ...item.term_ids,
                                                      //               {
                                                      //                 term_id:
                                                      //                   i._id,
                                                      //                 payment:
                                                      //                   final_product.payment,
                                                      //                 support_payment: true,
                                                      //               },
                                                      //             ]
                                                      //         : item.term_ids.filter(
                                                      //             (_i) =>
                                                      //               _i.term_id !==
                                                      //               i._id
                                                      //           ),
                                                      //     })
                                                      //   );
                                                      //   set_product_Data(
                                                      //     product_data
                                                      //   );
                                                      // }}
                                                    />
                                                    {i.title}
                                                  </div>
                                                </div>
                                              ))}
                                            </>
                                          ) : null}
                                        </>
                                      ) : null}
                                    </>
                                  ))
                                : null}

                              <div class="row">
                                <div class="col-md-6">
                                  <fieldset class="form-group">
                                    <h6>مبلغ</h6>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="basicInput"
                                      placeholder="مبلغ"
                                      value={price}
                                      onChange={(e) =>
                                        set_price(e.target.value)
                                      }
                                    />
                                  </fieldset>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <fieldset class="form-group">
                                    <h6>کد رهگیری</h6>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="basicInput"
                                      placeholder="کد رهگیری"
                                      value={_tracking_code}
                                      onChange={(e) =>
                                        set__tracking_code(e.target.value)
                                      }
                                    />
                                  </fieldset>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <fieldset class="form-group">
                                    <h6>توضیحات کوتاه</h6>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="basicInput"
                                      placeholder="توضیحات کوتاه"
                                      value={more_information}
                                      onChange={(e) =>
                                        set_more_information(e.target.value)
                                      }
                                    />
                                  </fieldset>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <fieldset>
                                    <h6>تصویر فیش واریزی</h6>
                                    <div class="input-group">
                                      <div class="input-group-prepend"></div>
                                      <div class="input-group">
                                        <div class="custom-file">
                                          <input
                                            type="file"
                                            class="custom-file-input"
                                            id="inputGroupFile02"
                                            onChange={(e) =>
                                              set_fish_img(e.target.files[0])
                                            }
                                          />
                                          <label
                                            class="custom-file-label"
                                            for="inputGroupFile02"
                                            aria-describedby="inputGroupFileAddon02"
                                          >
                                            {fish_img
                                              ? fish_img.name
                                              : "انتخاب فایل"}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-6">
                                  <fieldset>
                                    <h6>تصویر تاییدیه مدیریت</h6>
                                    <div class="input-group">
                                      <div class="input-group-prepend"></div>
                                      <div class="input-group">
                                        <div class="custom-file">
                                          <input
                                            type="file"
                                            class="custom-file-input"
                                            id="inputGroupFile02"
                                            onChange={(e) =>
                                              set_confirmation_photo(
                                                e.target.files[0]
                                              )
                                            }
                                          />
                                          <label
                                            class="custom-file-label"
                                            for="inputGroupFile02"
                                            aria-describedby="inputGroupFileAddon02"
                                          >
                                            {confirmation_photo
                                              ? confirmation_photo.name
                                              : "انتخاب فایل"}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                              </div>

                              {/* 
                              <input
                                type="number"
                                class="form-control"
                                style={{
                                  marginBottom: "10px",
                                }}
                                placeholder="شماره همراه"
                                value={phone_number}
                                onChange={(e) =>
                                  set_phone_number(e.target.value)
                                }
                              />
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="نام"
                                value={name}
                                onChange={(e) => set_name(e.target.value)}
                              />
                              <input
                                type="password"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="رمز عبور"
                                value={password}
                                onChange={(e) => set_password(e.target.value)}
                              />
                              <input
                                type="email"
                                class="form-control"
                                placeholder="ایمیل"
                                value={email}
                                onChange={(e) => set_email(e.target.value)}
                              /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {_tracking_code &&
              more_information &&
              (fish_img || confirmation_photo) ? (
                <button
                  onClick={() => {
                    sendData();
                  }}
                  style={{
                    marginTop: "-2rem",
                    marginRight: "25px",
                    width: "fit-content",
                  }}
                  type="button"
                  class="btn btn-success mr-1 mb-1 "
                >
                  افزودن تراکنش جدید
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { AddPaymentToUser };
